import { combineReducers } from '@reduxjs/toolkit';

import { baseApi } from '@klp/core/api';
import { appReducer } from '@klp/core/app/store';
import { apiSlice } from '@klp/core/api/store';
import { uxReducer } from '@forvalter/context/uxSlice';
import { portfolioReducer, regionReducer } from '@klp/portfolio';
import { userReducer } from '@klp/user';
import { contractToRegistrationReducer } from '@klp/contractregistration/store';
import contractToRegistrationSlice from '@klp/contractregistration/contractToRegistrationSlice';
import { kommentarerSelectorSlice } from '@klp/kommentarer/store/kommentarerSlice';
import { contextSelectorSlice } from '@klp/contextSelector/store/contextSelectorSlice';
import { surveySelectorSlice } from '@klp/survey/store/surveySlice';
import { frontpageSlice } from '@forvalter/frontpage';
import prosjektSlice from '@klp/prosjekt/store/prosjektSlice';
import { leverandorSlice } from '@klp/leverandor/store';

export const reducers = combineReducers({
    [baseApi.reducerPath]: baseApi.reducer,
    customApi: apiSlice.reducer,
    app: appReducer,
    ux: uxReducer,
    contextSelector: contextSelectorSlice.reducer,
    contractToRegistrationProcess: contractToRegistrationSlice?.reducer,
    portfolio: portfolioReducer,
    region: regionReducer,
    user: userReducer,
    contractRegistration: contractToRegistrationReducer,
    kommentarer: kommentarerSelectorSlice?.reducer,
    survey: surveySelectorSlice?.reducer,
    frontpage: frontpageSlice?.reducer,
    prosjekt: prosjektSlice?.reducer,
    leverandor: leverandorSlice?.reducer,
});
